import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Flex
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

export default function ConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  confirmColorScheme = "gray",
  showWarningIcon = false,
  isLoading = false,
  size,
  children
}) {
  const { t } = useTranslation('common');
  const resolvedMessage = message ?? t('confirmDialog.defaultMessage');
  const resolvedConfirm = confirmText ?? t('confirmDialog.defaultConfirm');
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={size}>
      <ModalOverlay />
      <ModalContent>
        {title && <ModalHeader>{title}</ModalHeader>}
        <ModalBody pt={title ? undefined : 6}>
          {children ? children : showWarningIcon ? (
            <Flex align="center" gap={3}>
              <WarningIcon color="redesign.accent.amber" boxSize={5} flexShrink={0} />
              <Text whiteSpace="pre-wrap">{resolvedMessage}</Text>
            </Flex>
          ) : (
            <Text whiteSpace="pre-wrap">{resolvedMessage}</Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose} isDisabled={isLoading}>
            {t('actions.cancel')}
          </Button>
          <Button
            {...(confirmColorScheme === 'red'
              ? { variant: 'danger' }
              : { colorScheme: confirmColorScheme })}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {resolvedConfirm}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
